module.exports = __webpack_public_path__ + "static/media/new-user.c7f45bb0.svg";